/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CancelAtPeriodEndResponse interface.
 */
export function instanceOfCancelAtPeriodEndResponse(value) {
    if (!('cancelAtPeriodEnd' in value) || value['cancelAtPeriodEnd'] === undefined)
        return false;
    if (!('currentPeriodEnd' in value) || value['currentPeriodEnd'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function CancelAtPeriodEndResponseFromJSON(json) {
    return CancelAtPeriodEndResponseFromJSONTyped(json, false);
}
export function CancelAtPeriodEndResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cancelAtPeriodEnd': json['cancel_at_period_end'],
        'currentPeriodEnd': json['current_period_end'],
        'status': json['status'],
    };
}
export function CancelAtPeriodEndResponseToJSON(json) {
    return CancelAtPeriodEndResponseToJSONTyped(json, false);
}
export function CancelAtPeriodEndResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cancel_at_period_end': value['cancelAtPeriodEnd'],
        'current_period_end': value['currentPeriodEnd'],
        'status': value['status'],
    };
}
